// Kody kafelków – lustro backend/worldgen/tiles.py (CHUNK_FORMAT_VERSION = 1).
export const CHUNK_FORMAT_VERSION = 1;

export const G = { VOID: 0, GRASS: 1, FOREST: 2, FARMLAND: 3, SAND: 4, WATER: 5, CONCRETE: 6, PAVING: 7, CEMETERY: 8, PARK: 9, RAILBED: 10 } as const;
export const R = { NONE: 0, MAJOR: 1, STREET: 2, DIRT: 3, PATH: 4, RAIL: 5, TRAM: 6, SIDEWALK: 7 } as const;
export const B = { NONE: 0, WALL: 1, FLOOR: 2, DOOR: 3 } as const;
export const O = { NONE: 0, TREE: 1, WRECK: 2, BARRICADE: 3, DEBRIS: 4, LAMP: 5, BUSH: 6, FENCE: 7 } as const;

const BLOCKING_GROUND = new Set<number>([G.VOID, G.WATER]);
const BLOCKING_OBJECT = new Set<number>([O.TREE, O.WRECK, O.BARRICADE, O.FENCE]);

export function isBlocked(ground: number, road: number, building: number, obj: number): boolean {
  if (building === B.WALL || BLOCKING_OBJECT.has(obj)) return true;
  if (BLOCKING_GROUND.has(ground) && road === R.NONE) return true;
  return false;
}
